export type RuntimeEnv = {
  contactApiUrl: string;
  recaptchaSiteKey: string;
};

type GlobalWithProcess = typeof globalThis & {
  process?: {
    env?: Record<string, string | undefined>;
  };
};

type EnvKey = 'VITE_CONTACT_API_URL' | 'VITE_RECAPTCHA_SITE_KEY';

export function getRuntimeEnv(): RuntimeEnv {
  const contactApiUrl = readEnvValue('VITE_CONTACT_API_URL');
  const recaptchaSiteKey = readEnvValue('VITE_RECAPTCHA_SITE_KEY');

  if (!contactApiUrl) {
    throw new Error('Missing VITE_CONTACT_API_URL');
  }

  if (!recaptchaSiteKey) {
    throw new Error('Missing VITE_RECAPTCHA_SITE_KEY');
  }

  return {
    contactApiUrl,
    recaptchaSiteKey,
  };
}

function readEnvValue(key: EnvKey): string | undefined {
  const viteEnvValue = readViteEnvValue(key);
  const nodeEnv = (globalThis as GlobalWithProcess).process?.env;

  return viteEnvValue ?? nodeEnv?.[key];
}

function readViteEnvValue(key: EnvKey): string | undefined {
  const value: unknown =
    key === 'VITE_CONTACT_API_URL'
      ? import.meta.env?.VITE_CONTACT_API_URL
      : import.meta.env?.VITE_RECAPTCHA_SITE_KEY;

  return typeof value === 'string' && value.length > 0 ? value : undefined;
}
